// @flow
import React from 'react';
import './App.css';

//Pages
import Home from './Pages/Home';
import E404 from './Errors/E404';

//Helpers
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { MediaQueryProvider } from 'react-media-query-hoc';
import Redirect from './Components/Functional/Redirect';

export default function (props: {}): React.DOM {
  return (
    <MediaQueryProvider>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route
            path="/terms-and-conditions"
            render={props => <Redirect to="https://www.iubenda.com/terms-and-conditions/88727190"/>}
          />
          <Route
            path="/privacy-policy"
            render={props => <Redirect to="https://www.iubenda.com/privacy-policy/88727190"/>}
          />
          <Route component={E404}/>
        </Switch>
      </BrowserRouter>
    </MediaQueryProvider>
  );
};



// WEBPACK FOOTER //
// ./src/App.js